var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tk-badges',{attrs:{"items":_vm.items,"removable":_vm.removable,"max-width-for-each-badge":300,"font-weight":"bold"},on:{"remove":_vm.removeFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }